
import { request } from '@/shared/api/request'

export const delGetXml = (data) => {
	return request({ url: `contract/civilLow/del/get/xml`, method: 'post', params: data })
}

export const getXml = (data) => {
	return request({ url: `contract/civilLow/get/xml`, method: 'post', data: data })
}

export const getContract = (externalId) => {
	return request({ url: `contract/civilLow/get/${externalId}`, method: 'get' })
}

export const page = (data, params, cache = false) => {
	return request({ url: `contract/civilLow/page`, method: 'post', params, data, cache: cache })
}

export const sendContract = (data) => {
	return request({ url: `contract/civilLow/sendContract`, method: 'post', data: data })
}

export const subDelGetXml = (data) => {
	return request({ url: `contract/civilLow/sub/del/get/xml`, method: 'post', params: data })
}

export const subGetXml = (data) => {
	return request({ url: `contract/civilLow/sub/get/xml`, method: 'post', data })
}

export const subSend = (data) => {
	return request({ url: `contract/civilLow/sub/send`, method: 'post', data })
}

export const termGetXml = (data) => {
	return request({ url: `contract/civilLow/term/get/xml`, method: 'post', data })
}

export const termSend = (data) => {
	return request({ url: `contract/civilLow/term/send`, method: 'post', data })
}